module.exports = __webpack_public_path__ + "static/jordan-peterson-d8dcd14edb126d4770fdcec2e2f672e8.jpg";